import { useFetchImgObjUrl } from "@/hooks/useFetchImgObjUrl";
import { ProductSchema } from "@labeling-tools/api/atlas";

interface Props {
  product: ProductSchema;
}

export const ProductImageThumbnail = (props: Props) => {
  const { product } = props;
  const image_id = product.id || "";
  const image_url = product.image_url || "";
  const { data: imgObjUrlResp } = useFetchImgObjUrl({
    image_url,
    img_id: image_id,
  });
  const imgObjUrl = imgObjUrlResp || "";

  return (
    <div className="size-8 border p-1 rounded">
      {!!imgObjUrl && (
        <img src={imgObjUrl} className="object-contain size-full" />
      )}
    </div>
  );
};
